// Helpers for grouping tags by category and filtering inactive tags.
// Active filtering: a tag is treated as active when is_active !== false (legacy
// rows that pre-date the field default to true).

export const isTagActive = (t) => t && t.is_active !== false;

/**
 * Group an array of tag objects by `category`, returning an ordered array of
 * { category, tags } so the UI renders consistently. Inactive tags are kept
 * unless `excludeInactive` is true.
 */
export function groupTagsByCategory(tags, { excludeInactive = false } = {}) {
  const src = excludeInactive ? tags.filter(isTagActive) : tags;
  const buckets = new Map();
  for (const t of src) {
    const cat = t.category || "General";
    if (!buckets.has(cat)) buckets.set(cat, []);
    buckets.get(cat).push(t);
  }
  // Sort categories alphabetically, but keep "General" last for visual hygiene
  const cats = Array.from(buckets.keys()).sort((a, b) => {
    if (a === "General") return 1;
    if (b === "General") return -1;
    return a.localeCompare(b);
  });
  return cats.map((category) => ({
    category,
    tags: buckets.get(category).sort((a, b) => a.name.localeCompare(b.name)),
  }));
}
